{
    angular.module('interfaceModule')
        .controller('MainController',MainController);
    MainController.$inject = ['$scope',"utils.currentUser",'utils.constant','$state','utils.common'];
    function MainController($scope,currentUser,constant,$state,common) {
        let vm=this;
        let collect={
            'activate':activate
        };
        vm.collect=collect;
        activate();

        function activate(){
            common.loading.show('正在读取登录信息...');
            currentUser.getUserInfo()
            .then(function(resData){
                // console.log(resData);
                common.loading.hide();
            },function(message){
                console.log(message);
                common.loading.hide();
                $state.go('login');
            });
        }
    }
    
}